import styled from "styled-components";

import { theme } from "../../../../../styles";
import Container from "../../../container/container";

export const SectionContainer = styled(Container)`
  background-color: ${theme.color.surface.background.weakest.default};
`;
